import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import "../style/Header.css";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleMenu = () => {
    const newMenuState = !isMenuOpen;
    setIsMenuOpen(newMenuState);

    if (newMenuState) {
      // Store current scroll position before opening menu
      const scrollY = window.scrollY;
      document.body.style.top = `-${scrollY}px`;
      document.body.classList.add('menu-open');
    } else {
      // Restore scroll position when closing menu
      const scrollY = document.body.style.top;
      document.body.classList.remove('menu-open');
      document.body.style.top = '';
      if (scrollY) {
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
      }
    }
  };

  const closeMenu = () => {
    // Restore scroll position when closing menu
    const scrollY = document.body.style.top;
    setIsMenuOpen(false);
    document.body.classList.remove('menu-open');
    document.body.style.top = '';
    if (scrollY) {
      window.scrollTo(0, parseInt(scrollY || '0') * -1);
    }
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const closeDropdown = () => {
    setIsDropdownOpen(false);
  };
  
  // Show/hide navbar on scroll (mobile only)
  useEffect(() => {
    let lastScrollY = window.scrollY;
    const navbar = document.querySelector(".navbar");

    const handleScroll = () => {
      // Don't handle scroll when menu is open to prevent interference
      if (isMenuOpen) return;
      
      if (window.innerWidth < 1001) {
        if (window.scrollY > lastScrollY && window.scrollY > 80) {
          navbar.style.transform = "translateY(-100%)"; // Hide navbar
        } else {
          navbar.style.transform = "translateY(0)"; // Show navbar
        }
        lastScrollY = window.scrollY;
      } else {
        // Reset transform for desktop view
        navbar.style.transform = "translateY(0)";
      }
    };

    const handleResize = () => {
      if (window.innerWidth >= 1001) {
        // Reset navbar on desktop
        navbar.style.transform = "translateY(0)";
        setIsMenuOpen(false);
        document.body.classList.remove('menu-open');
      }
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);
    
    // Initial check
    handleResize();

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, [isMenuOpen]);

  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <Link className="title" to="/" onClick={closeMenu}>
          <img src="/logo.png" alt="The Picky Kitty" className="logo" />
          <h1>The Picky Kitty</h1>
        </Link>
      </div>

      <div className="hamburger" onClick={toggleMenu}>
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
      </div>

      <ul className={`navbar-links ${isMenuOpen ? "active" : ""}`}>
        <li><Link to="/" onClick={closeMenu}>Home</Link></li>
        <li className="nav-featured"><Link to="/Database" onClick={closeMenu}>Cat Food Database</Link></li>
        <li className="nav-featured"><Link to="/Recommendations" onClick={closeMenu}>Get Recommendations</Link></li>
        <li><Link to="/Scanner" onClick={closeMenu}>Scanner</Link></li>
        <li><Link to="/Comparison" onClick={closeMenu}>Comparison</Link></li>
        <li><Link to="/Blog" onClick={closeMenu}>Blog</Link></li>
        <li><Link to="/About" onClick={closeMenu}>About</Link></li>
        
        {/* Desktop Dropdown */}
        <li className="desktop-dropdown">
          <div 
            className="dropdown-container"
            onMouseEnter={() => setIsDropdownOpen(true)}
            onMouseLeave={() => setIsDropdownOpen(false)}
          >
            <button 
              className="dropdown-toggle" 
              onClick={toggleDropdown}
            >
              More ▼
            </button>
            <ul className={`dropdown-menu ${isDropdownOpen ? "show" : ""}`}>
              <li><Link to="/Tools" onClick={closeMenu}>Tools</Link></li>
              <li><Link to="/Faq" onClick={closeDropdown}>FAQ</Link></li>
              <li><Link to="/Contact" onClick={closeDropdown}>Contact Us</Link></li>
                                      <li><a href="https://forms.gle/DmVsEtRtiMitEAMt5" target="_blank" rel="noopener noreferrer" onClick={closeDropdown}>Feedback</a></li>
              <li><a href="https://www.buymeacoffee.com/thepickykitty" target="_blank" rel="noopener noreferrer" onClick={closeDropdown}>Support Us</a></li>
            </ul>
          </div>
        </li>
        
        {/* Mobile Menu Items */}
        <li className="mobile-only"><Link to="/Tools" onClick={closeMenu}>Tools</Link></li>
        <li className="mobile-only"><Link to="/Faq" onClick={closeMenu}>FAQ</Link></li>
        <li className="mobile-only"><Link to="/Contact" onClick={closeMenu}>Contact Us</Link></li>
        
        {/* Feedback Button - Mobile Only */}
        <li className="mobile-feedback-item">
          <div className="feedback-container">
            <div className="feedback-text">Hiss? Purr? Tell me what you think!</div>
            <div className="feedback-content">
              <img src="/picky-kitty/feedback.png" alt="Feedback" className="feedback-image" />
                                      <a href="https://forms.gle/DmVsEtRtiMitEAMt5" target="_blank" rel="noopener noreferrer" onClick={closeMenu} className="feedback-button-link">
                <button className="feedback-button">
                  Share Feedback
                </button>
              </a>
            </div>
          </div>
        </li>
      </ul>
    </nav>
  );
};

export default Header;